import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import {
  MerchantPaymentBillingResponseItem,
  MerchantPaymentBillingTableData,
  MerchantPaymentBillingTableRowActions
} from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: MerchantPaymentBillingResponseItem[],
  actions: MerchantPaymentBillingTableRowActions
): MerchantPaymentBillingTableData[] =>
  data.map((merchantPaymentBillingItem: MerchantPaymentBillingResponseItem) => {
    const { cost, amount, id, ...rest } = merchantPaymentBillingItem;

    const actionsProp = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actions.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      amount: amount.value,
      actions: <ActionsColumn actions={actionsProp} />
    };
  });
